import * as React from "react";
import { CustomDetailsList, Loader } from "../../../shared";
import { useNavigate, useParams } from "react-router-dom";
import { Button } from "@mui/material";
import parse from "html-react-parser";

export const StampCardGeneralDetails = ({ state, isEditable, isPublished }) => {
  const navigate = useNavigate();
  const { id } = useParams();

  const columns = React.useMemo(
    () => [
      {
        title: "Stamp Card Name",
        accessor: "name",
      },
      {
        title: "Short Description",
        accessor: (row) => {
          return <div>{row?.description ? parse(row.description) : "--"}</div>;
        },
      },
      {
        title: "No of Stamps",
        accessor: "total_stamps",
      },
      {
        title: "Cycle Validity (Days)",
        accessor: "cycle_validity",
      },
    ],
    [],
  );


  return (
    <>
      {state?.isLoading ? (
        <Loader />
      ) : (
        <CustomDetailsList
          columns={columns}
          data={state?.data}
          title="General Details"
          headerRightContent={
            <>
              {isEditable && !isPublished && (
                <Button
                  size="medium"
                  variant="contained"
                  onClick={() => navigate(`/stamp-cards/details/${id}/edit`)}
                >
                  Edit
                </Button>
              )}
            </>
          }
        />
      )}
    </>
  );
};
